import { Waypoint, WAYPOINTS } from '../constants/mapLayers/waypoints';

export const getWaypointByTypeId = (typeId: string): Waypoint =>
  Object.values(WAYPOINTS).find(waypoint => waypoint.typeId === typeId) ?? WAYPOINTS.DEFAULT;
